<div ishFocusOutside (isFocusedOutside)="onFocusOutside($event)">
  <input
    [type]="showPassword ? 'text' : 'password'"
    [formControl]="formControl"
    [formlyAttributes]="field"
    class="form-control"
    [ngClass]="props.inputClass"
    [attr.data-testing-id]="field.key"
    [attr.aria-label]="props.ariaLabel | translate"
    [attr.aria-required]="props.required ? 'true' : undefined"
    [attr.aria-invalid]="showError ? 'true' : undefined"
    [attr.aria-describedby]="props.ariaDescribedByIds"
    (input)="onInput()"
  />

  <button
    *ngIf="showButton"
    type="button"
    role="switch"
    [attr.aria-checked]="showPassword"
    class="btn btn-link text-decoration-none"
    [attr.aria-label]="'form.password.show.button.label' | translate"
    (click)="togglePasswordVisibility()"
  >
    <fa-icon [icon]="['fas', showPassword ? 'eye-slash' : 'eye']" />
  </button>
</div>
